<template>
  <div>
    <div v-if="limsds_userDetails.userEmail != null && limsds_userDetails.userEmail != ''">
      <v-row dense><v-col sm="11">
        <v-data-table
         height="70vh"
         fixed-header
        :headers="headers"
        :items="favoriteList"
        sort-by="fav_id"
        item-key="fav_id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>My Favorite</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="text-h5">Edit Favorite </span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="8">
                        <v-text-field
                          v-model="editedItem.fav_name"
                          label="Favorite name"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        Site :- {{ editedItem.site }}
                        <br />
                        Page Name :- {{ editedItem.page_name }}
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="deleteItemConfirm(item)"
                    >OK</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize"> Reset </v-btn>
        </template>
      </v-data-table>
        </v-col></v-row>
      
    </div>
    <div v-if="limsds_userDetails.userEmail == null">
      <h3>INVALID USER !!!</h3>
      <h4>Current user is not exist in system database !!!</h4>
    </div>
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import axios from "axios";
import appMixin from "../mixins/app-mixin";
export default {
  name: "Favorite",
  mixins: [uiView, appMixin],
  components: {},
  props: {},
  data() {
    return {
      deleteID: 0,
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: "Favorite Name",
          align: "start",
          sortable: false,
          value: "fav_name",
          class: "primary white--text"
        },
        { text: "Site", value: "site" ,class: "primary white--text"},
        { text: "Area", value: "areas" ,class: "primary white--text"},
        { text: "Page Name", value: "page_name" ,class: "primary white--text" },
        { text: "Actions", value: "actions", sortable: false ,class: "primary white--text"},
      ],
      favoriteList: [],
      editedIndex: -1,
      editedItem: {
        fav_name: "",
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        fav_name: "",
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    if (this.limsds_userDetails.userEmail != null) {
        this.initialize();
      }
  },

  methods: {
    initialize() {
      const favList =
        this.settings.WAFavList + "userId=" + this.limsds_userDetails.userEmail + "&page_name=" + "";
      axios.get(favList).then((response) => {
        this.favoriteList = response.data.value;
      });
    },

    editItem(item) {
      this.editedIndex = this.favoriteList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.deleteID = item.fav_id;
      this.editedIndex = this.favoriteList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      const FavUpdateDelete =
        this.settings.WAFavUpdateDelete +
        "fav_id=" +
        this.deleteID +
        "&fav_name=&action=Delete";
      axios.get(FavUpdateDelete).then((response) => {
        //this.favoriteList = response.data.value;
      });
      this.favoriteList.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedItem.fav_name != "") {
        if (this.editedIndex > -1) {
          const FavUpdateDelete =
            this.settings.WAFavUpdateDelete +
            "fav_id=" +
            this.editedItem.fav_id +
            "&fav_name=" +
            this.editedItem.fav_name +
            "&action=Edit";
          axios.get(FavUpdateDelete).then((response) => {
            //this.favoriteList = response.data.value;
          });
          Object.assign(this.favoriteList[this.editedIndex], this.editedItem);
        } else {
          this.favoriteList.push(this.editedItem);
        }
        this.close();
      }
    },
  },
};
</script>

<style  lang="scss">
.v-data-table {
    line-height: 1 !important;
    max-width: 100%;
}
</style>
